<template>
  <div class="card-child xs-12 s-6 m-3">
    <img :src="user.avatar_icon" :alt="user.firstname" />
    <div class="dea-heading--medium__m card-child__firstname">{{ user.firstname }}</div>
    <div class="dea-heading--regular__ms card-child__email">{{ user.email }}</div>
    <div class="card-child__profile-child">
      <!-- FIXME: Temporary changed href url. Original value is $root.config.myfamily_url -->
      <Links
        class="dea-links dea-links--large dea-links--pointer"
        :class="`dea-links--${linksColor}`"
        href="https://users.deascuola.it/#/user/signup/profile/family/3"
        >Modifica il profilo di {{ user.firstname }}</Links
      >
    </div>
    <div class="card-child__personal-area">
      <Links class="dea-links dea-links--large dea-links--pointer" @click="openProfileModal('home')"
        >Vai all'area personale di {{ user.firstname }}</Links
      >
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import Links from "@/components/elements/Links";

export default {
  name: "CardChild",
  components: { Links },
  props: {
    linksColor: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    openProfileModal(eventName) {
      this.$emit("open-profile-modal", { userId: this.user.id, firstname: this.user.firstname, event: eventName });
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.card-child {
  margin-bottom: $space-large;
  text-align: center;

  &__firstname,
  &__email {
    margin-bottom: $space-small;
  }

  &__profile-child {
    margin-bottom: $space-x-small;
  }

  .dea-links {
    cursor: pointer;
  }
}
</style>
